import { useState, useCallback } from 'react';
import { themes } from '../theme';

export default function useTheme() {
  const [mode, setMode] = useState(
    () => localStorage.getItem('sm_theme') || 'light'
  );

  const toggle = useCallback(() => {
    setMode(m => {
      const next = m === 'light' ? 'dark' : 'light';
      localStorage.setItem('sm_theme', next);
      return next;
    });
  }, []);

  return { mode, theme: themes[mode], toggle };
}
